<template>
  <Card :header="$t('alerts')">
    <template #card-body>
      <div class="menu">
        <div
          :class="{ active: selectedMenu === 'byCap' }"
          @click="onMenuSelect('byCap')"
          class="menu-itm"
        >
          {{ $t('by-capabilities') }}
        </div>
        <div
          :class="{ active: selectedMenu === 'byTop' }"
          @click="onMenuSelect('byTop')"
          class="menu-itm"
        >
          {{ $t('by-top-10-applications') }}
        </div>
      </div>

      <div v-if="selectedMenu === 'byCap'" class="home-revm-flex-col">
        <div class="home-revm-flex-col">
          <div class="chart-container">
            <RadialChart
              :colors="radialColors"
              :chartCenterData="totalAlets"
              :legendValue="convertToK(totalAlets)"
              :legendTitle="$t('totalAlerts')"
              :label="labels"
              :series="percentages"
              :customStyle="{ height: '21rem' }"
            ></RadialChart>
            <!-- <RadialChart :customStyle="{height:'20rem'}"></RadialChart> -->
          </div>
          <div class="home-revm-flex-col">
            <InfoBoxContainer
              class="home-alerts-info-box-container"
              :loadingStatus="loading"
              :containersData="capabilities"
              @info-selected="handleItemClick"
            ></InfoBoxContainer>
          </div>
        </div>
      </div>
      <div v-if="selectedMenu === 'byTop'" class="home-revm-flex-col">
        <div class="home-revm-flex-col">
          <AppInfoContainer :apps="topApps"></AppInfoContainer>
        </div>
      </div>
    </template>
  </Card>
</template>

<script>
import Card from '@/rex-components/rex-card.vue';
import RadialChart from '@/components/charts/chart-radial.vue';
import InfoBoxContainer from './info-box-container.vue';
import AppInfoContainer from './app-info-container.vue';
import { getColor, getKey } from './util';
import graphQl from '@/services/graphQl';
import { mapGetters } from 'vuex';
import { capLabels } from './util';
import { convertToK } from '@/utils/helper-function';

export default {
  components: { Card, RadialChart, InfoBoxContainer, AppInfoContainer },
  data() {
    return {
      selectedMenu: 'byCap',
      capabilities: [
        {
          key: 'APM',
          value: '',
          color: getColor(0),
        },
        {
          key: this.$t('browserMonitoring'),
          value: '',
          color: getColor(1),
        },
        {
          key: this.$t('vmMonitoring'),
          value: '',
          color: getColor(2),
        },
        {
          key: this.$t('databaseMonitoring'),
          value: '',
          color: getColor(3),
        },
        {
          key: this.$t('mobileMonitoring'),
          value: '',
          color: getColor(4),
        },
        // {
        //   key: 'Web Server monitoring',
        //   value: '',
        //   color: getColor(5),
        // },
        {
          key: this.$t('syntheticMonitoring'),
          value: '',
          color: getColor(5),
        },
        {
          key: this.$t('k8m'),
          value: '',
          color: getColor(6),
        },
        {
          key: this.$t('mq.mqMonitoring'),
          value: '',
          color: getColor(7),
        },
        {
          key: this.$t('logMonitoring'),
          value: '',
          color: getColor(8),
        },
        {
          key: this.$t('analyticsCap'),
          value: '',
          color: getColor(9),
        },
        {
          key: this.$t('cloudSvc'),
          value: '',
          color: getColor(10),
        },
      ],
      loading: false,
      percentages: [],
      labels: capLabels,
      totalAlets: 0,
      radialColors: [
        getColor(0),
        getColor(1),
        getColor(2),
        getColor(3),
        getColor(4),
        getColor(5),
        getColor(6),
        getColor(7),
        getColor(8),
        getColor(9),
        getColor(10),
      ],
      topApps: [],
      map: {},
    };
  },
  methods: {
    onMenuSelect(option) {
      this.selectedMenu = option;
    },
    async getData() {
      try {
        this.loading = true;
        const params = {
          condition: {
            entity: {
              scope: 'All',
            },
          },
          duration: this.getDurationTime,
        };
        const {
          data: {
            data: {
              topAlertsByCapability: { alertCount },
            },
          },
        } = await graphQl.query('queryTopAlertsByCap').params(params);
        let count = 0;
        let percentages = [];
        alertCount.sort((a, b) => parseFloat(b.alerts) - parseFloat(a.alerts));
        if (alertCount && Array.isArray(alertCount)) {
          let sortedLables = alertCount.map((e) => getKey(e.capability));
          this.labels = sortedLables;
          this.capabilities = alertCount.map((e, index) => ({
            key: getKey(e.capability),
            value: e.alerts + '',
            color: getColor(index),
          }));
          this.radialColors = this.capabilities.map((e) => e.color);
          alertCount.forEach((ele) => {
            if (this.map[ele.capability]) {
              this.map[ele.capability].value = ele.alerts + '';
              count += ele.alerts;
              percentages.push(ele.alerts);
            }
          });
        }
        this.totalAlets = count;
        this.percentages = percentages.map((ele) =>
          Math.floor((ele / count) * 100),
        );
      } catch (error) {
        console.log('error', error);
      } finally {
        this.loading = false;
      }
    },
    handleItemClick(data) {
      this.$router.push({
        name: 'alertsV2',
        query: { capability: data.app },
      });
    },
    async getTopApps() {
      try {
        this.loading = true;
        const params = {
          condition: {
            entity: {
              scope: 'All',
            },
          },
          duration: this.getDurationTime,
        };
        const {
          data: {
            data: {
              topApps: { alertsApps },
            },
          },
        } = await graphQl.query('queryTopAppsByAlert').params(params);

        if (alertsApps && Array.isArray(alertsApps)) {
          this.topApps = alertsApps.map((app) => {
            let appInfo = {};

            appInfo.app = app.serviceName;
            appInfo.value = app.count;
            appInfo.capability = app.capability;
            appInfo.serviceId = app.serviceId;
            return appInfo;
          });
          this.topApps = this.topApps.sort(
            (a, b) => parseFloat(b.value) - parseFloat(a.value),
          );
        }
      } catch (error) {
        console.log('error', error);
      } finally {
        this.loading = false;
      }
    },
    convertToK,
  },
  mounted() {
    this.map = {
      A: this.capabilities[0],
      B: this.capabilities[1],
      V: this.capabilities[2],
      D: this.capabilities[3],
      M: this.capabilities[4],
      // W: this.capabilities[5],
      S: this.capabilities[5],
      K: this.capabilities[6],
      Q: this.capabilities[7],
      L: this.capabilities[8],
      ANL: this.capabilities[9],
      C: this.capabilities[10],
    };
    this.getData();
    this.getTopApps();
  },
  watch: {
    getDurationTime(newValue) {
      this.getData();
      this.getTopApps();
    },
  },
  computed: {
    ...mapGetters('globalState/settings', ['getDurationTime', 'intervalTime']),
  },
};
</script>

<style lang="scss" scoped>
.menu {
  display: flex;
  margin-bottom: 1rem;
}
.menu-itm {
  flex: 1;
  padding: 0.5rem;
  cursor: pointer;
}
.active {
  color: $color-brand-accent;
  border-bottom: 2px solid $color-brand-accent;
}
.home-alerts-info-box-container {
  height: 27rem;
  overflow-y: scroll;
}

.home-revm-flex-col {
  display: flex;
  flex-direction: column;
}
</style>
